import { httpClient } from "../_core/httpClient";

export async function getUsernameByEmail(data) {
  try {
    const response = await httpClient.post("/auth/get-username-by-email", data, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 400) {
      return {
        status: 400,
        message: "Nome de usuário nao fornecido.",
      };
    }

    return {
      status: 500,
      message: "Erro ao buscar usuário.",
    };
  }
}
